(function () {
  'use strict';

  var routes = {
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    cart: '/cart.js',
    searchSuggest: '/search/suggest.json'
  };

  /* ---------- Utilities ---------- */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function trapFocus(container, initialFocus) {
    var focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeydown);
    (initialFocus || first).focus();

    return function () {
      container.removeEventListener('keydown', onKeydown);
    };
  }

  function fetchSections(ids) {
    return fetch('/?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (res) { return res.json(); });
  }

  function extractHTML(sectionHTML, selector) {
    var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    return doc.querySelector(selector);
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}').replace('{{amount}}', value);
  }

  /* ---------- Mobile menu ---------- */

  var mobileMenu = qs('[data-mobile-menu]');
  var releaseMenuFocus = null;

  function openMobileMenu(trigger) {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    releaseMenuFocus = trapFocus(mobileMenu);
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    var trigger = qs('[data-mobile-menu-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (releaseMenuFocus) releaseMenuFocus();
    if (trigger) trigger.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-toggle]')) openMobileMenu(e.target.closest('[data-mobile-menu-toggle]'));
    if (e.target.closest('[data-mobile-menu-close]')) closeMobileMenu();
  });

  /* ---------- Search modal ---------- */

  var searchModal = qs('[data-search-modal]');
  var searchInput = qs('[data-search-input]');
  var searchResults = qs('[data-search-results]');
  var searchTimer = null;

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    if (searchInput) searchInput.focus();
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) openSearch();
    if (e.target.closest('[data-search-close]')) closeSearch();
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (term.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch(routes.searchSuggest + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,vendor,product_type')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="search-modal__empty">' + (window.ShorreFindsStrings ? window.ShorreFindsStrings.noResults : 'No results found.') + '</p>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : (p.image || '');
              return '<a class="search-result" href="' + p.url + '">' +
                (img ? '<span class="search-result__media"><img src="' + img + '" alt="" loading="lazy"></span>' : '') +
                '<span><span class="search-result__title">' + p.title + '</span>' +
                '<span class="search-result__price">' + (p.price || '') + '</span></span></a>';
            }).join('');
          })
          .catch(function () {});
      }, 260);
    });
  }

  /* ---------- Cart drawer ---------- */

  var cartDrawer = qs('[data-cart-drawer]');
  var cartOverlay = qs('[data-cart-overlay]');
  var releaseCartFocus = null;

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    releaseCartFocus = trapFocus(cartDrawer);
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    if (releaseCartFocus) releaseCartFocus();
  }

  function refreshCartDrawer() {
    return fetchSections(['cart-drawer']).then(function (data) {
      var html = data['cart-drawer'];
      if (!html) return;
      var newBody = extractHTML(html, '[data-cart-body]');
      var newFooter = extractHTML(html, '[data-cart-footer]');
      var currentBody = qs('[data-cart-body]');
      var currentFooter = qs('[data-cart-footer]');
      if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;
      if (newFooter && currentFooter) currentFooter.outerHTML = newFooter.outerHTML;
    });
  }

  function refreshCartCount() {
    return fetch(routes.cart).then(function (res) { return res.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      openCartDrawer();
      refreshCartDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) closeCartDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    if (mobileMenu && mobileMenu.classList.contains('is-open')) closeMobileMenu();
    if (searchModal && searchModal.classList.contains('is-open')) closeSearch();
  });

  /* Cart line quantity + remove (event delegation) */
  function changeLine(key, quantity, lineEl) {
    lineEl.classList.add('is-loading');
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return Promise.all([refreshCartDrawer(), refreshCartCount()]);
      })
      .catch(function () {
        lineEl.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var input = qs('[data-qty-input]', line);

    if (e.target.closest('[data-qty-increase]')) {
      changeLine(key, parseInt(input.value, 10) + 1, line);
    }
    if (e.target.closest('[data-qty-decrease]')) {
      changeLine(key, Math.max(0, parseInt(input.value, 10) - 1), line);
    }
    if (e.target.closest('[data-cart-remove]')) {
      changeLine(key, 0, line);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty-input]')) {
      var line = e.target.closest('[data-cart-line]');
      var key = line.getAttribute('data-line-key');
      changeLine(key, Math.max(0, parseInt(e.target.value, 10) || 0), line);
    }
  });

  /* ---------- Add to cart (product & quick forms) ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtns = qsa('[type="submit"]', form);
    if (form.id) submitBtns = submitBtns.concat(qsa('[type="submit"][form="' + form.id + '"]'));
    var statusEl = qs('[data-form-status]', form);
    if (statusEl) statusEl.innerHTML = '';
    submitBtns.forEach(function (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    });

    var formData = new FormData(form);
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data.description || result.data.message || 'error');
        }
        return refreshCartCount().then(function () {
          if (window.ShorreFindsCartType === 'page') {
            window.location.href = routes.cart;
            return;
          }
          return refreshCartDrawer().then(openCartDrawer);
        });
      })
      .catch(function (err) {
        if (statusEl) {
          statusEl.innerHTML = '<p class="form-status form-status--error">' + (err.message || 'This item could not be added to your bag.') + '</p>';
        }
      })
      .finally(function () {
        submitBtns.forEach(function (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
  });

  /* ---------- Scroll reveal ---------- */

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    var revealTargets = qsa('[data-animate]');
    /* home-motion.js claims product grids it stagger-reveals with Motion; skip them here to avoid a double reveal */
    if (window.ShorreFindsGridMotionOwned) {
      revealTargets = revealTargets.filter(function (el) { return !el.closest('[data-motion-grid]'); });
    }
    if (revealTargets.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      revealTargets.forEach(function (el) { observer.observe(el); });
    }
  } else {
    qsa('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  window.ShorreFinds = window.ShorreFinds || {};
  window.ShorreFinds.trapFocus = trapFocus;
  window.ShorreFinds.fetchSections = fetchSections;
  window.ShorreFinds.refreshCartCount = refreshCartCount;
})();
